import axios from 'axios'
import { Message } from 'element-ui';
import router from '../../../router/index'
import util from '../util/util'
import config from '../config'
import Vue from 'vue'

// 创建一个 axios 实例
const service = axios.create({
    withCredentials: true,
    baseURL: config.baseUrl + '/api/',
    timeout: 3600000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        if(config.needAdmin !== false){
            config.url = 'school/' + config.url
        }
        config.method = config.method ? config.method : 'POST'

        if(config.method.toUpperCase() == 'GET'){
            let params = [], data = config.data
            for(var i in data){
                params.push(i +'=' + data[i])
            }
            if(params.length > 0){
                config.url += '?' + params.join('&')
            }
        }

        let authToken = util.cacheGet("authTokenSchool");
        if(authToken) {
            config.headers['Authorization'] = authToken;
        }
        return config
    },
    error => {
        // 发送失败
        // console.log(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {

        if(response.data.status == 0){

            if(response.data.code == 'A0230'){
                // 需要登录了！
                util.cacheSet("authTokenSchool", null);
                util.cacheSet('admin_login_messgae', '请先登录！');
                if(window.location.href.indexOf('/login') == -1){
                    router.push({
                        name: 'Login',
                    })
                }
            }else{
                // 后端未返回文案时（典型场景：全局异常处理取 e.getMessage() 为 null 的 NPE）
                // 会弹出一个只有图标、没有文字的空白提示条，这里补默认文案并在控制台留痕，
                // 便于定位是哪个接口失败。
                if(!response.data.msg){
                    console.warn('[api] 接口返回失败但未提供提示文案：', response.config && response.config.url, response.data)
                }
                Message({
                    message: response.data.msg || '操作失败，请稍后重试',
                    type: 'error'
                });
            }
        }
        return response.data
    },
    error => {
        Message({
        	message: '系统错误！请联系管理员',
        	type: 'error'
        });
        if (error && error.response) {
            console.log(error.response)
        }
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/assets/js/api/index.js